import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

export default function SessionExpiredModal({ open, onOk }) {
  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-[420px] rounded-2xl p-0 overflow-hidden border border-border/60 shadow-xl">
        <div className="px-6 py-6 space-y-6">
          {/* Header */}
          <div className="flex items-start gap-4">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary shrink-0">
              <ShieldAlert className="h-5 w-5" />
            </div>

            <div className="space-y-1.5">
              <DialogTitle className="text-lg font-semibold text-foreground">
                Session Expired
              </DialogTitle>
              <DialogDescription className="text-sm text-muted-foreground leading-relaxed">
                For security reasons, your session has expired. Please sign in
                again to continue.
              </DialogDescription>
            </div>
          </div>

          {/* Actions */}
          <div className="flex justify-end">
            <Button
              onClick={onOk}
              className="min-w-[90px] rounded-lg font-medium"
            >
              Sign In Again
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
